import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, OnInit, inject } from '@angular/core';
import { FormArray, FormGroup, UntypedFormBuilder } from '@angular/forms';
import { takeUntil } from 'rxjs';
import { isEqual } from 'lodash-es';
import { BaseComponent } from '@src/app/modules/base';

import { ProductAddressDataType } from '../geocoder-form-field';

import { FormType } from './types';

@Component({
  selector: 'geocoder-form',
  templateUrl: './geocoder-form.component.html',
  styleUrls: ['./geocoder-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeocoderFormComponent extends BaseComponent implements OnInit {
  private readonly formBuilder = inject(UntypedFormBuilder);

  @Input() set value(mapObjects: Array<ProductAddressDataType>) {
    if (!isEqual(mapObjects, this.mapObjectsControl.value)) {
      this.mapObjectsControl.clear();
      mapObjects.forEach(() => {
        this.addMapObject();
      });

      this.form.patchValue({ mapObjects });
    }
    this.cdr.markForCheck();
  }

  @Output() valueChange = new EventEmitter<Array<ProductAddressDataType>>();

  form = new FormGroup<FormType>({
    mapObjects: new FormArray<FormGroup>([]),
  });

  get mapObjectsControl() {
    return this.form.controls.mapObjects;
  }

  ngOnInit(): void {
    this.mapObjectsControl.valueChanges.pipe(takeUntil(this.destroyed$$)).subscribe(data => {
      this.valueChange.emit(data as ProductAddressDataType[]); // TODO: Поправить тип
    });
  }

  addMapObject() {
    this.mapObjectsControl.push(this.createMapObject());
  }

  deleteByIndex(index: number) {
    this.mapObjectsControl.removeAt(index);
  }

  private createMapObject(): any {
    return this.formBuilder.group({
      address: [''],
      longitude: [],
      latitude: [],
    });
  }
}
